import { useEffect } from 'react';

/**
 * Make iframes transparent to the pointer while a drag is live.
 *
 * The editor drags over a live preview iframe (and the deck overview sits above
 * one). A same-origin iframe still owns the events that land inside it: they're
 * dispatched in ITS document and never reach ours. So a mouseup released over
 * the preview is a mouseup dnd-kit's sensors never see — the drag never ends,
 * the row keeps its dragging class, and the slide sits greyed out until the
 * user reloads. That was the whole reported bug, and swapping in a drag library
 * does not fix it on its own: pointer capture is what the old hand-rolled code
 * used to beat the iframe, and dnd-kit's mouse sensor doesn't use capture.
 *
 * `pointer-events: none` while dragging hands those events back to us, and also
 * stops the pointer stalling as it crosses the preview mid-drag.
 *
 * Pass the live drag id (or any truthy "dragging now" value).
 */
export function useIframeDragGuard(dragging: unknown) {
  useEffect(() => {
    if (!dragging) return undefined;
    document.body.classList.add('is-dragging');
    return () => document.body.classList.remove('is-dragging');
  }, [dragging]);
}
